{
  "国家或地区管理": "Country and region management",
  "标准名称": "Standard name",
  "留空使用标准名称：{{name}}": "Leave blank to use {{name}}",
  "自定义名称": "Custom name",
  "代码、标准名称或自定义名称": "Code, standard name, or custom name",
  "该国家或地区未开放": "This country or region is not available",
  "区号": "Calling code",
  "搜索区号": "Search calling codes",
  "启用状态": "Availability",
  "短信状态": "SMS status",
  "创蓝状态": "Chuanglan status",
  "已设置": "Set",
  "短信": "SMS",
  "创蓝": "Chuanglan",
  "可发送": "Reachable",
  "未开通": "Not opened",
  "同步创蓝价格": "Sync Chuanglan prices",
  "已同步创蓝可发送地区": "Synced countries Chuanglan can reach",
  "一键开启短信": "Enable SMS for filtered regions",
  "一键关闭短信": "Disable SMS for filtered regions",
  "批量启用": "Enable selected",
  "批量停用": "Disable selected",
  "批量开启短信": "Enable SMS for selected",
  "批量关闭短信": "Disable SMS for selected",
  "当前筛选结果": "the current filter results",
  "已选记录": "the selected records",
  "将更新{{scope}}中的 {{count}} 个国家或地区。": "Update {{count}} countries or regions in {{scope}}.",
  "无区号地区已跳过。": "Regions without a calling code are skipped.",
  "没有可更新的国家或地区": "No eligible countries or regions to update",
  "已更新 {{count}} 个国家或地区": "Updated {{count}} countries or regions",
  "无区号地区不支持开启短信": "SMS cannot be enabled for regions without a calling code",
  "请提供要修改的状态": "Provide a status to update"
}
